module.exports = __webpack_public_path__ + "images/icons/gb.49b72ffa36ccb225198703a33a3480f0.png";